import { FormattedMessage } from 'react-intl';

import TimestampAndMileage from '@/features/engineoil/components/TimestampAndMileage';
import { getBarColorClass, getThresholdClass } from '@/features/engineoil/utils/utils';
import type { EngineOil } from '@/generated/GeneratedApiTypes';
import BasePanel from './BasePanel';

interface Tbm3SsSingleCardProps {
    engineOil: EngineOil;
}

// Tbm3SsSingle = TBM3 device, sensor-signal-single reading.
// State is always unknown; only status (danger/warning/normal) is resolved from percentage.
const Tbm3SsSingleCard = ({ engineOil }: Tbm3SsSingleCardProps) => {
    const { status, measurement, measured_at } = engineOil;

    const thresholdClass = getThresholdClass(status);
    const barColorClass = getBarColorClass(status);
    const percentage = measurement != null ? Math.round(measurement) : 0;

    return (
        <BasePanel
            thresholdClass={thresholdClass}
            testId="card-workshop-tbm3-sensor_signal_single"
            subTitleKey="intl-msg:engineOil.card.ssSingle.subTitle"
        >
            <div className="display-flex flex-wrap">
                <TimestampAndMileage timestamp={measured_at.date} mileage={measured_at.mileage_km} />
            </div>

            <div className="width-100pct display-flex align-items-center padding-top-10">
                <div className="progress margin-0 flex-1-0" style={{ height: '10px' }}>
                    <div className={`progress-bar ${barColorClass}`.trim()} style={{ width: `${percentage}%` }} />
                </div>
                <div className="margin-left-10 text-color-gray-darkest">{`${percentage} %`}</div>
            </div>

            <div className="text-size-14 text-color-darkest margin-top-10 margin-bottom-10">
                <span className="rioglyph rioglyph-dangerousgoods margin-right-5" />
                <FormattedMessage id="intl-msg:engineOil.card.ssSingle.banner.notAccurate" />
            </div>
        </BasePanel>
    );
};

export default Tbm3SsSingleCard;
